import React from 'react'
import Swal from "sweetalert2";
import { getTvCompatibilityMessage } from "../service/tvCompatibilityMessage";
export const useGetplan = (props) => {

  const { descuento, descuento_valor, precio_persona, nombreplan, tipoplan, velocidad, precio_empresa, id__planes, codigo_open, ruta } = props;
  const isTvCard = Boolean(props?.isTvCard);
  const precioPlan = precio_persona;
  const precioDescuento = descuento_valor;
  const precio = descuento != null ? parseInt(precioDescuento[props.estrato] || precioDescuento.valor) : parseInt(precioPlan[props.estrato] || precioPlan.valor);
  console.log(props);
  window.sessionStorage.setItem("Nombreplan", nombreplan);
  window.sessionStorage.setItem("Plan", tipoplan);
  window.sessionStorage.setItem("Velocidad", velocidad);
  window.sessionStorage.setItem("PrecioPersona", precio);
  window.sessionStorage.setItem("PrecioEmpresa", precio_empresa.valor);
  window.sessionStorage.setItem("id_plan", id__planes);
  window.sessionStorage.setItem("plan_type", tipoplan);
  window.sessionStorage.setItem("id_plan_open", codigo_open);

  Swal.fire({
    title: nombreplan,
    ...(isTvCard
      ? { html: getTvCompatibilityMessage() }
      : { text: "¿Quieres el paquetes seleccionado?" }),
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Comprar",
  }).then((result) => { 
    if (result.isConfirmed) {
      window.location.href = ruta;
    }
  });
}